<template>
    <div>
        <div id="navigationPlaceholder" style="padding-top: 80px;">
            <AdminNavigationV2 :tid="tid"></AdminNavigationV2>
        </div>

        <div class="container">
            <div class="row">
                <div class="col-lg-7">
                    <h1 style="font-size: 2em; font-weight: 300; color: #33475b;">Manage runs</h1>
                </div>
                <div class="col-lg-5 col-sm-6 text-right">
                </div>
            </div>
        </div>

        <hr style="border-color: #bbb; margin: 20px 0 30px;" />

        <div class="container">
            <div class="list-group">
                <a v-for="r in runs" :key="r.RunId"
                   :href="`/#/admin/integrations/runs/details/${tid}/${r.RunId}`"
                   class="list-group-item list-group-item-action"
                   :class="{'list-group-item-secondary': r.Queued, 'list-group-item-primary': r.Running, 'list-group-item-success': r.Succeed, 'list-group-item-danger': (r.Failed || r.Aborted) && !r.Succeed}">
                    <div class="d-flex w-100 justify-content-between">
                        <div>
                            <h6 class="mb-1">
                                <span v-if="r.Running">[Running]</span>
                                <span v-else-if="r.Succeed">[Succeed]</span>
                                <span v-else-if="r.Failed">[Failed({{r.FailuresCount}})]</span>
                                <span v-else-if="r.Aborted">[Aborted]</span>
                                <span v-else>[Queued]</span>
                                <span>{{r.PipelineName}}</span>
                            </h6>
                            <p class="mb-1">
                                {{r.Trigger}}
                                <span v-if="r.QueuedByName">by {{r.QueuedByName}}</span>
                                <span>{{r.QueuedAtSinceNow}} ago</span>
                                <span v-if="r.StartedAtSinceNow">/ started {{r.StartedAtSinceNow}} ago</span>
                                <span v-if="r.CompletedAtSinceNow">/ completed {{r.CompletedAtSinceNow}} ago</span>
                                <span v-if="r.FailedAtSinceNow">/ failed {{r.FailedAtSinceNow}} ago</span>
                                <span v-if="r.AbortedAtSinceNow">/ aborted {{r.AbortedAtSinceNow}} ago</span>
                            </p>
                        </div>
                        <div class="text-right">
                            <small>{{r.LastActivityAtSinceNow}} ago</small>
                            <br />
                            <small>{{r.Duration}}</small>
                        </div>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { computed, ref, reactive, watch, onMounted } from 'vue'
    import { useId, useOrganizationUnitId } from '@common/composables'
    import { useAdminManageRunsPage } from '@Integrations/Runs/pages-core'
    import AdminNavigationV2 from '@common/AdminNavigationV2.vue'

    document.title = "Manage runs"

    const tid = useOrganizationUnitId()

    const { useCurrentUserQuery, useRunsOfOrganizationQuery } = useAdminManageRunsPage()

    const { modelCurrentUserQueryV1, runCurrentUserQueryV1 } = useCurrentUserQuery()
    const userId = computed(() => modelCurrentUserQueryV1.value?.UserId)

    const { modelRunsOfOrganizationQueryV1, runRunsOfOrganizationQueryV1 } = useRunsOfOrganizationQuery(tid)
    const runs = computed(() => modelRunsOfOrganizationQueryV1.value?.Runs || [])

    onMounted(() => {
        runCurrentUserQueryV1()
        runRunsOfOrganizationQueryV1()
    })
</script>
